import { render } from "./FooterKSI.vue?vue&type=template&id=096a5a0c&scoped=true"
import script from "./FooterKSI.vue?vue&type=script&lang=js"
export * from "./FooterKSI.vue?vue&type=script&lang=js"

import "./FooterKSI.vue?vue&type=style&index=0&id=096a5a0c&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096a5a0c"]])

export default __exports__